export {
  PHOTO_TYPE_FACE,
  PHOTO_TYPE_TONGUE,
} from './photo';

export const SET_WKWEBVIEW_PREVIEW_PHOTO = 'SET_WKWEBVIEW_PREVIEW_PHOTO';

export const RESET_WKWEBVIEW_PREVIEW_PHOTO = 'RESET_WKWEBVIEW_PREVIEW_PHOTO';

export const setWkwebviewPreviewPhotoAction = ({ src, photoType }) => ({
  type: SET_WKWEBVIEW_PREVIEW_PHOTO,
  src,
  photoType,
});

export const resetWkwebviewPreviewPhoto = () => ({
  type: RESET_WKWEBVIEW_PREVIEW_PHOTO,
});



// WEBPACK FOOTER //
// ./src/actions/wkwebview.js